
$(document).ready(() => {
	if($('#monthlyOptions').prop('checked')){
		$('#giftCheckbox').prop('disabled', true);
		$('.gift-check').addClass('disabled');
	}
	// product option type tab
	$('.product-types .product-option').on('click', function (evt) {
		evt.stopPropagation();
		evt.preventDefault();

		$('.product-option input').each(function () {
			$(this).prop('checked', false)
		});
		$('.product-types .product-option').each(function () {
			$(this).removeClass('pp-selected');
		});

		$(this).find('input').prop('checked', true);
		$(this).addClass('pp-selected');

		if($(this).hasClass('toggle-recharge')){
			$('.product-option-monthly, .product-option-prepaid').css('display', 'flex');
			$('.quantity-selector__wrapper').hide();
			$('.product-extra-box .product-extra-option .product-option input').each(function (index) {
				if(index == 0){
					$(this).prop('checked', true)
				}else{
					$(this).prop('checked', false)
				}
			});

		}else{
			$('.product-option-monthly, .product-option-prepaid').css('display', 'none');
			$('.quantity-selector__wrapper').show();
		}

		// reset subscription price
		const optionId = $(this).children('input').attr('id');

		if (optionId == 'subscribeSave') {
			$('.product-extra-option').each(function(index){
				$(this).removeClass('pp-selected');
				if(index == 0) $(this).addClass('pp-selected');
			})
			

			if($('#monthlyOptions').prop('checked')){
				$('#giftCheckbox').prop('checked', false);
				$('#productGiftInput').hide();
				$('#giftCheckbox').prop('disabled', true);
				$('.gift-check').addClass('disabled');
			}

			let subscribePrice = ($('.current-price').data('price')) / 100;
			$('.current-price').empty().append(`$${subscribePrice}/MO`);
			$('.ftb-atc-text').empty().append('JOIN NOW');
		} else {
			$('#giftCheckbox').prop('disabled', false);
			$('.gift-check').removeClass('disabled');
			let otpPrice = ($('.current-price').data('otp-price')) / 100;
			$('.current-price').empty().append(`$${otpPrice}`);
			$('.ftb-atc-text').empty().append('ADD TO CART');
		 }

		$('.select-options').hide();
	});

	$('.product-extra-option .product-option').on('click', function (evt) {
		evt.stopPropagation();
		evt.preventDefault();
		const optionId = $(this).children('input').attr('id');

		if (optionId == 'monthlyOptions') {
			let selectedMonthlyOption = $(this).closest('.product-extra-option').find('.select-monthly option:selected');
			let monthlyPrice = selectedMonthlyOption.data('price');
			$('.current-price').empty().append(`${monthlyPrice}/MO`);
			$('.ftb-atc-text').empty().append('JOIN NOW');

			$('#giftCheckbox').prop('disabled', true);
			$('#giftCheckbox').prop('checked', false);
			$('#productGiftInput').hide();
			$('.gift-check').addClass('disabled');
		} else {
			let selectedPrepaidOption = $(this).closest('.product-extra-option').find('.select-pre-paid option:selected');
			let prepaidPrice = selectedPrepaidOption.data('total-price');
			$('.current-price').empty().append(prepaidPrice);
			$('.ftb-atc-text').empty().append('JOIN NOW');

			$('#giftCheckbox').prop('disabled', false);
			$('.gift-check').removeClass('disabled');
		}

		$('.product-extra-box .product-extra-option .product-option input').each(function (index) {
			$(this).prop('checked', false)
		});
		$(this).find('input').prop('checked', true);
		$('.product-extra-option').each(function(){
			$(this).removeClass('pp-selected');
		})
		$(this).closest('.product-extra-option').addClass('pp-selected');

	});


	// Custom Selector
	$('.select_variant').each(function () {
		var SelectClass = $(this).attr('class').split(' ')[0];
		var isPrepaid = $(this).hasClass('select-prepaid');

		$(this).each(function () {
			var $this = $(this), numberOfOptions = $(this).children('option').length;

			$this.addClass('select-hidden');
			$this.wrap('<div class="select pseudo-' + SelectClass + '"></div>');
			$this.after('<div class="select-styled"></div>');

			var $styledSelect = $this.next('div.select-styled');
			var elementPrice = getElementPrice($this.children('option:selected'));
			var elementTotalPrice = getElementTotalPrice($this.children('option:selected'));
			var selectedItem = '<img src="' + $this.children('option:selected').attr("data-icon") + '" />' + '<span class="plan-name 3">' + $this.children('option:selected').text() + '</span><p class="prices">Change species anytime!</p>';

			if (isPrepaid) {
				var text = ($this.children('option:selected').text()).split('\n');
				var prepaidTextDesktop = (text[1]).split('-');

				selectedItem = `
					<span class="prepaid-mobile">
						<span class="plan-name 3">
							${text[0]}<br>
							<span class="prepaid-total">${text[1]}</span>
						</span>
					</span>

					<span class="prepaid-desktop">
						<span class="plan-name">
							${text[0]} - ${prepaidTextDesktop[0]} 
							<span class="prepaid-total">${prepaidTextDesktop[1]}</span>
						</span>
					</span>
					`;
			}

			if (selectedItem !== "") {
				var selectedItemText = selectedItem;
			} 
			$styledSelect.html(selectedItemText);

			var $list = $('<ul />', {
				'class': 'select-options'
			}).insertAfter($styledSelect);

			for (var i = 0; i < numberOfOptions; i++) {
				var elementPrice = getElementPrice($this.children('option').eq(i));
				var elementTotalPrice = getElementTotalPrice($this.children('option').eq(i));

				var prepaidDesktopText = $this.children('option').eq(i).text();

				if ($this.hasClass('select-prepaid')) {
					var text = ($this.children('option').eq(i).text()).split('\n');

					var prepaidTextDesktop = (text[1]).split('-');

					let prepaidText = `<span class="prepaid-mobile"><span class="plan-name">${text[0]}<br><span class="prepaid-total">${text[1]}</span></span></span>

						<span class="prepaid-desktop"><span class="plan-name">${text[0]} - ${prepaidTextDesktop[0]} <span class="prepaid-total">${prepaidTextDesktop[1]}</span></span></span>
						`;

					$('<li />', {
						html: prepaidText
					}).attr('data-value', $this.children('option').eq(i).val()).appendTo($list);
				} else {
					$('<li />', {
						html: '<img src="' + $this.children('option').eq(i).attr("data-icon") + '" />' + '<span class="plan-name">' + $this.children('option').eq(i).text() + '</span><p class="prices">' + elementPrice + elementTotalPrice + '</p>'
					}).attr('data-value', $this.children('option').eq(i).val()).appendTo($list);
				}
			}

			var $listItems = $list.children('li');

			$styledSelect.click(function (e) {
				e.stopPropagation();
				$('div.select-styled.active').not(this).each(function () {
					$(this).removeClass('active').next('ul.select-options').hide();
				});
				$(this).toggleClass('active').next('ul.select-options').toggle();
			});

			$listItems.click(function (e) {
				
				e.stopPropagation();
				$styledSelect.html($(this).html()).removeClass('active');

				var val = $(this).attr('data-value');
				$this.children('option').each(function (indx, element) {
					$(element).removeAttr("selected");
					if ($(element).val() === val) {
						$(element).prop('selected', true);
					}
				});
				$list.hide();
				$this.change();

				let selectedOption = $this.find('option:selected');
				if($this.hasClass('select-pre-paid')){
					let prepaidPrice = selectedOption.data('total-price');
					$('.current-price').empty().append(prepaidPrice);
					$('.ftb-atc-text').empty().append('JOIN NOW');
				}else{
					let monthlyPrice = selectedOption.data('price');
					if(monthlyPrice){
						$('.current-price').empty().append(`${monthlyPrice}/MO`);
						$('.ftb-atc-text').empty().append('JOIN NOW');
					}
					
				}
			});

			$(document).click(function () {
				$styledSelect.removeClass('active');
				$list.hide();
			});
		});
	});

	// product gift checkbox
	$('#giftCheckbox').on('click', function (evt) {
		$('.gift-input').toggle();
	});

	// collection carousel
	$('.pcc-outer').slick({
		infinite: true,
		slidesToShow: 3,
		slidesToScroll: 1,
		autoplaySpeed: 2000,
		arrows: true,
		adaptiveHeight: true,
		responsive: [
			{
				breakpoint: 800,
				settings: {
					slidesToShow: 1,
					arrows: false
				}
			}
		]

	})
	.on('setPosition', function (event, slick) {

		var $slickTextBox = $('.pcc-product p');
		var maxHeight = 0;

		// loop through and find the tallest box
		$slickTextBox.each(function(e) {
			if (maxHeight < $(this).outerHeight()) {
				maxHeight = $(this).outerHeight();
			}
		});

		// set all textboxes to same height
		$slickTextBox.each(function (e) {
			$(this).height(maxHeight);
		});

		$(window).resize(function () {
			$slickTextBox.each(function (e) {
				$(this).height(maxHeight);
			});
		});
	});
});

function getElementPrice(el) {
	var dataPrice = $(el).attr("data-price");
	if (typeof dataPrice === "undefined" || !dataPrice) {
		return '';
	}
	var price = "<span class='price'>" + dataPrice + '</span>';
	return price
}

function getElementTotalPrice(el) {
	var dataTotalPrice = $(el).attr("data-total-price");
	if (typeof dataTotalPrice === "undefined" || !dataTotalPrice) {
		return '';
	}
	var totalPrice = "<span class='total-price'>" + dataTotalPrice + "</span>";
	return totalPrice
}